import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EventItem, Lookups, Race} from "@model";
import {RaceService} from "@services";
import {Router} from "@angular/router";
import {ORGANISER_RACE_MANAGEMENT} from "../../../../../../app-routing.module";

@Component({
    selector: 'app-event-management-race-list',
    templateUrl: './event-management-race-list.component.html',
    styleUrl: './event-management-race-list.component.scss',
    standalone: false
})
export class EventManagementRaceListComponent {
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) eventItem?: EventItem;
  @Input({required: true}) disableRegisterToRace: boolean = false;
  @Output() registerToRace: EventEmitter<void> = new EventEmitter<void>();
  @Output() getFileFromServer: EventEmitter<string> = new EventEmitter<string>();
  @Output() generateRegistrationQRCode: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private raceService: RaceService,
    private router: Router
  ) {
  }

  goToRaceManagement(race: Race): void {
    if (race && race.id) {
      this.raceService.setCurrentRace(race);
      this.router.navigate([ORGANISER_RACE_MANAGEMENT], {queryParams: {eventId: this.eventItem!.id, raceId: race.id}});
    }
  }

  onRegisterToRace() {
    this.registerToRace.next();
  }

  downloadRaceRegistrationQRCode() {
    this.generateRegistrationQRCode.next();
  }

  onGetFileFromServer(type:string) {
    this.getFileFromServer.next(type);
  }
}
